<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | Firmware change log
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style="display:flex; justify-content: space-between; align-items: center;")
      //- .form-group(v-bind:class="{'col-md-3': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Date:
        v-select(v-bind:value.sync='logFilter.date.value' v-bind:options='logFilter.date.opts')
      .form-group.col-md-3
        label.control_label
          | Search:
        input.form-control(v-model="searchQuery" placeholder="Search firmware" style="display: inline-block; width: auto;")
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-3': $route.name === 'smart-controller'}")
        label.control_label
          | Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
      .form-group.col-md-3(v-if="$route.name === 'smart-controller'")
        label.control_label
          | Domain:
        v-select(v-bind:value.sync='logFilter.domain.value' v-bind:options='logFilter.domain.opts')
      .form-group.col-md-2(v-if="$route.name === 'smart-controller'")
        label.control_label
          | Model:
        v-select(v-bind:value.sync='logFilter.model.value' v-bind:options='logFilter.model.opts')
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Custom:
        v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
      .form-group
        label.control_label
          | Layer:
        v-select(v-bind:value.sync='logFilter.layer.value' v-bind:options='logFilter.layer.opts')
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}" v-if="user.role === 'admin'")
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
      .form-group
        label.control_label
          | Spec:
        v-select(v-bind:value.sync='logFilter.spec.value' v-bind:options='logFilter.spec.opts')
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div(ng-if="fwLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredTotalLog'
      )
      .col-md-12
        //- span {{pi | json}}
        //- span {{firmware | json}}
        //- span {{customFilteredTotalLog[0] | json}}
        //- span {{switch | json}}
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in searchFilteredTotalLog | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media
                .media-left
                  .media-object.device_icon(v-bind:class="p.category")
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body
                  .media-top
                    //- span {{p.updatedAt | timeFormat}}
                    span.version
                      span(style="margin-right: 4px") {{p.version}}
                      span.glyphicon.glyphicon-link(class="copy-icon" @click="copyToClipboard(p.version)" style="font-size: medium;")
                    span.time
                      span.glyphicon.glyphicon-time
                      span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ p.createdAt | fromNow }}
                      span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ p.updatedAt | fromNow }}
                    span.model.type_tag.base_black.base_grey_bg {{getCustomForUI(p.custom)}}
                    span.model.type_tag.base_black.base_white_bg(v-if="p.isReadOnly && user.role === 'admin'") ReadOnly
                    span.model.type_tag.base_black.base_white_bg(v-if="['router', 'routerx'].includes(p.category) && p.firmwareLayer != null") Layer {{ p.firmwareLayer }}
                    span.model.type_tag.base_blue.base_grey_bg(v-if="$route.name === 'smart-controller' && p.domain != null") {{p.domain}}
                    //- span {{p.url}}
                    .action_buttons.pull-right
                      .btn-group
                        button.btn.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="['admin'].includes(user.role) || user.email === 'jacky@lantechcom.tw'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-default(@click="handleShowDeleteConfirm(p['.key'], p.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        a.btn.btn-default(v-if="p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin' || user.email.endsWith('intrising.com.tw')" v-on:click='handleDownload(p.url, $event)' v-bind:disabled="p.url === ''")
                          span.glyphicon.glyphicon-cloud-download
                          span(v-if="$route.name === 'switch'")  Firmware
                          span(v-else)  Download
                        a.btn.btn-default(v-if="p.category !== 'smart-controller' && p.status === 'release' || user.role === 'admin'" v-on:click='handleDownload(p.testReportUrl, $event)' v-bind:disabled="p.testReportUrl === ''")
                          span.glyphicon.glyphicon-list-alt
                          span  Test Report
                  .media-middle
                    line-table(title='MD5' v-bind:content='p.md5' v-if='p.md5 != null && p.md5.length !== 0')
                    line-table(title='Model' v-bind:is-md="true" v-bind:content='p.modelTxt' v-if='p.modelTxt != null && p.modelTxt.length !== 0')
                    line-table(title='Release Notes' v-bind:is-md="true" v-bind:default-collapse="user.role!='vendor'" v-bind:content='p.releaseNote' v-if='p.releaseNote.length !== 0')
                    line-table(title='Internal Logs' v-bind:is-md="true" v-bind:content='p.internalLog' v-if='p.internalLog.length !== 0 && user.role === "admin"')
                .media-right.badge_group
                  .customized__badge(v-bind:class="p.status")
                    span {{p.status}}
      .col-md-12(v-if="searchFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isUpdatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='isReleasedAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='category' v-bind:value.sync='selectedCategory' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Custom:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='customOpts' v-bind:value.sync='selectedCustom' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="selectedCategory === 'smart-controller'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Domain:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='domainOpts' v-bind:value.sync='selectedDomain' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="selectedCategory === 'smart-controller'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='modelOpts' v-bind:value.sync='selectedModel' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.version
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='version' v-bind:placeholder.sync='versionPlaceholder' v-bind:class="{'error': showInvalidMsg}" v-bind:readonly="user.role !== 'admin'")
          span.text-danger(v-if='showInvalidMsg')
            | Please follow the format of placeholder
        div(v-if="$route.name === 'smart-controller'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label.download
                | Download Link:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        div(v-else)
          .form-group.col-md-12.clearfix(v-if="['router', 'routerx'].includes(selectedCategory)")
            .col-md-3.form_label.clearfix
              label.control_label
                | Layer:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options="[{label: '2', value: 2}, {label: '3', value: 3}]" v-bind:value.sync='firmwareLayer' v-bind:disabled="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Firmware
                span.glyphicon.glyphicon-cloud-download
                | :
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='url' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | MD5 :
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='md5' placeholder='' v-bind:readonly="user.role !== 'admin'")
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Test Report:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='testReportUrl' placeholder='www.google.com' v-bind:readonly="user.role !== 'admin'")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='status' v-bind:value.sync='selectedStatus' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='modelTxt' placeholder='' v-bind:disabled="user.role !== 'admin' && user.email !== 'jacky@lantechcom.tw'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Notes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='releaseNote' placeholder='[TopologyView] support LLDP discover\n[EventLog  ] Cold Start Log.' v-bind:disabled="user.role !== 'admin' && user.email !== 'jacky@lantechcom.tw'")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Internal Logs:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='internalLog' placeholder='[MSTP] If VLAN trunk is not the same to each other, the topology will loop.' v-bind:disabled="user.role !== 'admin' && user.email !== 'jacky@lantechcom.tw'")
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin'")
          .col-md-3.form_label.clearfix
            label.control_label
              | Is Read Only: {{ isReadOnlyStr }}
          .col-md-9.no_pad.clearfix
            checkbox(:checked.sync="isReadOnlyStr" value="true") Yes
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
</template>
<script>
import moment from 'moment'
import { datepicker, modal, select, spinner, checkbox } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { store, getDb, getFireBase, getCustomForUI, getIconSrc, filterOptions, naturalSorting } from '../../index.js'
import _ from 'lodash'
const fb = getFireBase()
const PI = 'smart-controller'
const SWITCH_CATEGORY = filterOptions.category
const PI_CATEGORY = [
  {label: 'Smart-controller', value: PI}
]
const PI_CUSTOM = [
  {label: 'Gomax', value: 'gomax'},
  {label: 'Gofanco', value: 'gofanco'}
]
const SWITCH_CUSTOM = filterOptions.custom

export default {
  components: {
    datepicker,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    checkbox
  },
  vuex: {
    getters: {
      user: state => state.user,
      firmwareInfo: state => state.firmware
    }
  },
  data () {
    return {
      fwLoaded: false,
      dynamicTitle: '',
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Category',
          value: 'category'
        },
        {
          label: 'Sort by Version',
          value: 'version'
        }
      ],
      postFix: {
        all: '',
        ite: 'i',
        aspeed: 'a'
      },
      category: [],
      selectedCategory: PI,
      selectedCustom: 'gomax',
      selectedStatus: 'develop',
      selectedDomain: 'intri',
      selectedModel: 'all',
      version: '',
      customOpts: [],
      domainOpts: [],
      modelOpts: [],
      firmwareLayer: 2,
      url: '',
      md5: '',
      testReportUrl: '',
      modelTxt: '',
      releaseNote: '',
      internalLog: '',
      isReadOnlyStr: '',
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      status: filterOptions.status.firmware,
      logFilter: {
        custom: {
          opts: [],
          value: 'any'
        },
        date: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '1 month', value: 'month'}
          ],
          value: 'any'
        },
        category: {
          opts: [], // dynamic generated by $route.name
          value: 'any'
        },
        domain: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'Intri', value: 'intri'},
            {label: 'Eagleyes', value: 'eagleyes'},
            {label: 'EvoIP', value: 'evoip'}
          ],
          value: 'any'
        },
        model: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: 'ITE', value: 'ite'},
            {label: 'ASPEED', value: 'aspeed'}
          ],
          value: 'any'
        },
        status: {
          opts: [],
          value: 'any'
        },
        layer: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '2', value: 2},
            {label: '3', value: 3}
          ],
          value: 'any'
        },
        spec: {
          opts: [],
          value: 'any'
        }
      },
      isUpdate: false,
      isUpdatedAt: '',
      isReleasedAt: '',
      versionPlaceholder: 'V1.10.1',
      showInvalidMsg: false,
      firmware: {},
      searchQuery: '',
      initSpec: ''
    }
  },
  ready () {
    this.$refs.spinner.show()
    // set the category , model and  custom opts
    let optAny = {label: 'Any', value: 'any'}
    if (this.$route.name !== PI) {
      this.dynamicTitle = 'Switch Firmware Change Log'
      this.category = _.cloneDeep(SWITCH_CATEGORY)
      this.selectedCategory = 'swix1'
      if (['pandacom@lantechcom.tw', 'db@lantechcom.tw'].includes(this.user.email)) {
        this.logFilter.category.opts = [{label: 'RouterX', value: 'routerx'}]
      } else {
        this.logFilter.category.opts = _.cloneDeep(SWITCH_CATEGORY)
      }
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(SWITCH_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      this.logFilter.status.opts = _.cloneDeep(filterOptions.status.firmware)
      this.logFilter.status.opts.unshift(optAny)
      this.selectedCustom = 'lantech'
      this.customOpts = SWITCH_CUSTOM
    } else {
      this.dynamicTitle = 'Smart-Controller Firmware Change Log'
      this.category = _.cloneDeep(PI_CATEGORY)
      this.selectedCategory = PI
      this.logFilter.category.opts = _.cloneDeep(PI_CATEGORY)
      this.logFilter.category.opts.unshift(optAny)
      this.logFilter.custom.opts = _.cloneDeep(PI_CUSTOM)
      this.logFilter.custom.opts.unshift(optAny)
      this.selectedCustom = 'gomax'
      this.customOpts = PI_CUSTOM
      this.selectedModel = 'ite'
      this.modelOpts = [
        {label: 'ITE', value: 'ite'},
        {label: 'ASPEED', value: 'aspeed'}
      ]
      this.selectedDomain = 'intri'
      this.domainOpts = [
        {label: 'Intri', value: 'intri'},
        {label: 'Eagleyes', value: 'eagleyes'},
        {label: 'EvoIP', value: 'evoip'}
      ]
    }
    // console.log('this.firmwareInfo', this.firmwareInfo)
    this.logFilter.category.value = this.$route.query.category || (this.firmwareInfo.category !== '' ? _.find(this.logFilter.category.opts, {value: this.firmwareInfo.category}).value : 'any')
    this.logFilter.custom.value = this.$route.query.custom || (this.firmwareInfo.custom !== '' ? _.find(this.customOpts, {value: this.firmwareInfo.custom}).value : 'any')
    this.logFilter.layer.value = this.$route.query.layer === 'any' ? 'any' : parseInt(this.$route.query.layer) || 'any'
    this.logFilter.status.value = this.$route.query.status || 'any'
    this.initSpec = this.$route.query.spec || 'any'
    this.searchQuery = this.$route.query.search || ''
    store.dispatch('firmwareInfoDelete')

    if (this.user.custom != null) {
      this.getFwData(this.user.custom)
    }
  },
  computed: {
    parseSpec () {
      const parseVersion = (version) => {
        if (typeof version !== 'string') return [];
        return version.split('_')
          .map(part => part.replace(/-/g, ''))   // remove hyphens
          .filter(val => /^\d{4}$/.test(val));   // keep 4-digit numbers
      };

      const allMatches = this.totalLog.flatMap(d => {
        if (this.user.role !== 'admin') {
          if (d.status === 'develop' && !this.user.email.endsWith('intrising.com.tw')) return [];
        }
        return parseVersion(d.version);
      });
      return [...new Set(allMatches)]
        .sort((a, b) => b - a)  // sort from largest spec num to smallest spec num
        .map(value => ({ label: value, value }));
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    totalLength () {
      return this.searchFilteredTotalLog.length
    },
    totalLog () {
      if (this.$route.name === PI) {
        return this.pi.sort((a, b) => {
          return b.updatedAt - a.updatedAt
        })
      } else {
        let swi = this.firmware
        // // specific filter pandacom
        // if (['pandacom@lantechcom.tw', 'db@lantechcom.tw'].includes(this.user.email)) {
        //   swi = swi.filter(x => x.category === 'routerx' && ['V2.01.87', 'V4.01.18'].includes(x.version))
        // }
        const { name, asc: isAsc } = this.sortMethod
        if (name === 'version') {
          return naturalSorting(_.filter(swi, (x) => x.version), 'version', isAsc ? 'asc' : 'desc')
        } else {
          return _.orderBy(swi, [name], [isAsc ? 'asc' : 'desc'])
        }
      }
    },
    specFilteredTotalLog() {
      const spec = this.logFilter.spec.value;
      if (spec === 'any') return this.totalLog;

      const dashedSpec = `${spec.slice(0, 2)}-${spec.slice(2, 4)}`;

      return this.totalLog.filter(p =>
        typeof p.version === 'string' && (p.version.includes(`_${spec}_`) || p.version.includes(`_${dashedSpec}_`))
      );
    },
    dateFilteredTotalLog () {
      return this.specFilteredTotalLog.filter(p => {
        return this.logFilter.date.value !== 'any' ? moment(p.updatedAt).isBetween(moment().subtract(1, 'months'), moment()) : true
      })
    },
    categoryFilteredTotalLog () {
      return this.dateFilteredTotalLog.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
    },
    domainFilteredTotalLog () {
      return this.categoryFilteredTotalLog.filter(p => {
        return this.logFilter.domain.value !== 'any' ? p.domain === this.logFilter.domain.value : true
      })
    },
    modelFilteredTotalLog () {
      return this.domainFilteredTotalLog.filter(p => {
        return this.logFilter.model.value !== 'any' ? p.model === this.logFilter.model.value : true
      })
    },
    layerFilteredTotalLog () {
      return this.modelFilteredTotalLog.filter(p => {
        return this.logFilter.layer.value !== 'any' ? p.firmwareLayer === this.logFilter.layer.value : true
      })
    },
    statusFilteredTotalLog () {
      switch (this.user.role) {
        case 'admin':
          return this.layerFilteredTotalLog.filter(p => {
            return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
          })
        default:
          return this.layerFilteredTotalLog.filter(p => {
            return p.status !== 'develop' || this.user.email.endsWith('intrising.com.tw')
          })
      }
    },
    customFilteredTotalLog () {
      // update select.option for user permission
      if (!(typeof this.user.custom === 'undefined' && typeof this.user.role === 'undefined')) {
        switch (this.user.role) {
          case 'admin':
            break
          case 'vendor':
            if (this.user.email.endsWith('intrising.com.tw')) {
              break
            }
            this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'carrier_switch')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'intrising')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'microsens_npd7')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'sercomm_dragon')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any' ||
              obj.value.startsWith('lantech_') ||
              (this.user.custom === 'lantech_lantech' && obj.value.startsWith('lantech_')) // allow any lantech_ prefix
            )
            break
          case 'client':
            this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'carrier_switch')
            this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'viewer')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'intrising')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'microsens_npd7')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'sercomm_dragon')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any' || /* obj.value.toLowerCase() === 'lantech' || */ obj.value.toLowerCase() === this.user.custom.toLowerCase() || (this.user.email === 'eu@lantechcom.tw' && obj.value === 'lantech_pandacom'))
            break
          default:
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any')
            break
        }
        return this.statusFilteredTotalLog.filter(p => {
          return this.logFilter.custom.value !== 'any'
          ? p.custom === this.logFilter.custom.value
          // filter data in user-permission clustered custom-option
          : typeof (_.find(this.logFilter.custom.opts, {value: p.custom})) !== 'undefined'
        })
      } else {
        return []
      }
    },
    searchFilteredTotalLog () {
      return this.customFilteredTotalLog.filter(p => {
        return p.version.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               p.category.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
               p.custom.toLowerCase().includes(this.searchQuery.toLowerCase())
      })
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type,
        title,
        content
      })
    },
    handleDownload (url, e) {
      window.open(url)
    },
    getCustomForUI,
    getSmartControllerClass (model) {
      switch (model) {
        case 'ite': return 'ite_color_bg'
        case 'aspeed': return 'aspeed_color_bg'
        case 'default': return 'base_black base_grey_bg'
      }
    },
    getIconSrc,
    handleShowModal (which, key, index) {
      // console.log('key', key)
      // console.log('index', index + this.pageStart)

      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add firmware'
        this.isUpdate = false
        this.okText = 'Add'
        this.internalLog = ''
        this.selectedCustom = 'lantech_lantech'
        this.modelTxt = ''
        this.releaseNote = ''
        this.version = ''
        this.firmwareLayer = 2
        this.url = ''
        this.md5 = ''
        this.testReportUrl = ''
        this.isReadOnlyStr = ''
        this.isReleasedAt = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit firmware'
        this.isUpdate = true
        let { updatedAt = '', createdAt = '', internalLog = '', modelTxt = '', releaseNote = '', version, firmwareLayer, url, md5 = '', testReportUrl = '', domain = '', custom, category, status, isReadOnly = false } = this.searchFilteredTotalLog[index + this.pageStart]
        // console.log(version)
        this.isUpdatedAt = ''
        this.isUpdatedAt = moment(updatedAt).format('YYYY-MM-DD HH:mm:ss')
        this.isReleasedAt = ''
        this.isReleasedAt = moment(createdAt).format('YYYY-MM-DD HH:mm:ss')
        this.internalLog = internalLog
        this.modelTxt = modelTxt
        this.releaseNote = releaseNote
        this.selectedCategory = category
        this.selectedDomain = domain
        this.selectedCustom = custom
        this.selectedStatus = status
        if (['router', 'routerx'].includes(category)) {
          if (firmwareLayer != null) this.firmwareLayer = firmwareLayer
          else this.firmwareLayer = 2
        }
        this.url = url
        this.md5 = md5
        this.testReportUrl = testReportUrl
        this.okText = 'Update'
        this.modalCb = this.applyUpdate
        this.version = version
        this.isReadOnlyStr = isReadOnly ? 'true' : null
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    isVersionValid () {
      if (this.selectedModel === 'ite') {
        return this.version.startsWith('sciV')
      } else if (this.selectedModel === 'aspeed') {
        return this.version.startsWith('scaV')
      }
    },
    applyUpload () {
      this.showInvalidMsg = false
      let toPush = {
        customCategoryVersion: `${this.selectedCustom}_${this.selectedCategory}_${this.version}`,
        internalLog: this.internalLog,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: this.selectedCustom,
        releaseNote: this.releaseNote,
        md5: this.md5,
        modelTxt: this.modelTxt,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true'
      }
      if (['router', 'routerx'].includes(toPush.category)) {
        toPush.firmwareLayer = this.firmwareLayer
      }
      getDb().ref('firmware').push(toPush)
      this.showModal = false
    },
    async applyUpdate () {
      // let createdAt = ''
      // await this.$firebaseRefs[key].once('value').then(snapshot => {
      //   let snap = snapshot.val()
      //   for (let i of Object.keys(snap)) {
      //     if (i === this.editingKey) {
      //       createdAt = snap[i].createdAt
      //       break
      //     }
      //   }
      // })
      const update = {
        internalLog: this.internalLog,
        category: this.selectedCategory,
        createdAt: (new Date(this.isReleasedAt)).getTime(),
        custom: this.selectedCustom,
        releaseNote: this.releaseNote,
        md5: this.md5,
        modelTxt: this.modelTxt,
        status: this.selectedStatus,
        testReportUrl: this.testReportUrl,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url: this.url,
        version: this.version,
        isReadOnly: this.isReadOnlyStr === 'true'
      }
      if (['router', 'routerx'].includes(this.selectedCategory)) {
        update.firmwareLayer = this.firmwareLayer
      }
      if (this.user.role === 'admin') getDb().ref('firmware').child(this.editingKey).update(update)
      else if (this.user.role === 'vendor') {
        getDb().ref('firmware').child(this.editingKey).update({
          updatedAt: fb.database.ServerValue.TIMESTAMP,
          modelTxt: this.modelTxt,
          releaseNote: this.releaseNote,
          internalLog: this.internalLog
        })
      }
      this.showModal = false
    },
    applyDelete () {
      // console.log(this.editingKey)
      getDb().ref('firmware').child(this.editingKey).remove()
      this.showDeleteConfirm = false
    },
    getFwData (custom) {
      const isEu = this.user.email === 'eu@lantechcom.tw'  // HACK: the multi-custom access workarround for this account
      let query = ['admin', 'vendor'].includes(this.user.role) || isEu
          ? getDb().ref('firmware')
          : getDb().ref('firmware').orderByChild('custom').startAt(custom).endAt(custom)
      query.off()
      query.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.fwLoaded = true
          this.firmware = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => isEu ? ['lantech_lantech', 'lantech_pandacom'].includes(x.custom) : true)
        },
        () => {
          query.off()
        }
      )
    },
    updateQueryParams() {
      const query = {
        category: this.logFilter.category.value,
        custom: this.logFilter.custom.value,
        status: this.logFilter.status.value,
        layer: this.logFilter.layer.value,
        spec: this.logFilter.spec.value
      }
      if (this.searchQuery) {
        query.search = this.searchQuery
      }
      this.$router.replace({ query })
    },
    copyToClipboard(version) {
      const url = `${window.location.origin}/firmware?category=any&custom=any&layer=any&search=${version}&status=any`
      navigator.clipboard.writeText(url).then(() => {
        console.log('success', 'URL Copied', 'The URL has been copied to your clipboard.')
      }).catch(err => {
        console.error('error', 'Copy Failed', 'Failed to copy the URL.')
      })
    },
    isValidSpec(value, opts) {
      return opts.some(opt => opt.value === value);
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
        this.updateQueryParams()
      }
    },
    searchQuery: function (newQuery) {
      this.updateQueryParams()
    },
    'user.custom' (curr, prev) {
      if (curr != null) {
        this.getFwData(curr)
      }
    },
    parseSpec: function(newSpec) {
      this.logFilter.spec.opts = newSpec
      this.logFilter.spec.opts.unshift({label: 'Any', value: 'any'})

      if (this.initSpec === '') return
      if (this.logFilter.spec.opts.length >= 1 && this.isValidSpec(this.initSpec, this.logFilter.spec.opts)) {
        this.logFilter.spec.value = this.initSpec
        this.initSpec = ''
      } else if (this.logFilter.spec.opts.length >= 2 && !this.isValidSpec(this.initSpec, this.logFilter.spec.opts)) {
        this.logFilter.spec.value = 'any'
        this.initSpec = ''
      } else {
        this.logFilter.spec.value = 'any'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
// .container{
//   max-width: 1150px;
// }
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{

  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  overflow: hidden;
}
.badge_group{
  padding-right: 40px;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-56px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-50px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.copy-icon {
  cursor: pointer;
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// FwChangeLog.vue?0b905a23